<div id="app-content-root">
  <app-dialog-box></app-dialog-box>
  <app-message-box></app-message-box>
  <app-sidebar [isOpen]="isSidebarOpen" [showDefaultHeader]="showDefaultHeader" [bigSize]="true" (close)="handleSidebarClose($event)">
    <ng-container *ngTemplateOutlet="sidebarContent?.template"></ng-container>
  </app-sidebar>
  <app-photo-preview
    [isOpen]="isPhotoPreviewOpen"
    [src]="photoPreviewContent?.src"
    [fileName]="photoPreviewContent?.fileName"
    (close)="handlePhotoPreviewClose($event)"
  >
  </app-photo-preview>

  <div class="content">
    <router-outlet></router-outlet>
    <footer [class.d-none]="hideFooter">
      <small>© {{ year }} Hogia Fastighetssystem AB</small>
    </footer>
  </div>
</div>
